window.tailwindConfig = {
  theme: {
    extend: {
      colors: {},
      fontFamily: {
        barlow: ['Barlow', 'sans-serif'],
      },
      maxWidth: {
        'container': '1200px',
      },
      screens: {
        'xxl': '1200px',
      },
    },
  },
};
